<template>
  <button
    type="button"
    :disabled="disabled"
    @click="prompt()"
  >
    <slot>
      <div class="button is-white is-small">
        <div class="icon has-text-grey">
          <i class="mdi mdi-delete mdi-18px" />
        </div>
      </div>
    </slot>
  </button>
</template>

<script>
export default {
  props: {
    url: {
      required: true,
      type: String
    },
    type: {
      required: false,
      type: String,
      default: "is-grey"
    },
    message: {
      type: String,
      default () {
        return this.$t("confirm_delete");
      }
    },
    disabled: {
      default: false,
      type: Boolean
    }
  },
  methods: {
    prompt() {
      if (this.disabled) {
        return;
      }
      this.$buefy.dialog.confirm({
        title: this.$t("delete_record"),
        message: this.message,
        confirmText: this.$t("delete_record"),
        cancelText: this.$t("cancel"),
        type: "is-danger",
        hasIcon: false,
        onConfirm: () => this.destroy()
      });
    },

    destroy() {
      this.$http.delete(this.url)
        .then(response => {
          if (response.data && response.data.message) {
            this.$notificator.open({
              message: response.data.message,
              type: "success"
            });
          }
          this.$emit("success", response);
        })
        .catch(error => {
          this.$emit("error", error);
        });
    }
  }
};
</script>
